// extracted by mini-css-extract-plugin
module.exports = {"paymentStatus":"Payouts_paymentStatus__24-ST","payoutsDisabled":"Payouts_payoutsDisabled__3OE2G","exchangeRateNotSet":"Payouts_exchangeRateNotSet__2znVK"};